import type { Comic } from "@/mocks/homeData";

interface Props {
  comic: Comic;
}

export default function ComicCard({ comic }: Props) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1.5">
      <div className="relative overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}短篇漫画封面`}
          className="aspect-[3/4] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-bold text-secondary-900">
          {comic.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h4 className="font-heading text-base text-foreground-950">
          {comic.title}
        </h4>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {comic.intro}
        </p>
        <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {comic.mins}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {(comic.views / 1000).toFixed(1)}k
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-3-line text-primary-500" />
            {(comic.likes / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </article>
  );
}